import { PopoverContent, PopoverContentProps } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

export type MonthRangePopupProps = PropsWithChildren<PopoverContentProps>;

export const MonthRangePopup: FC<MonthRangePopupProps> = ({ children, ...rest }) => {
	return <PopoverContent {...rest}>{children}</PopoverContent>;
};
